module.exports = __webpack_public_path__ + "img/welcome.7eeb34ef.png";